import { render, staticRenderFns } from "./PackageListDropdown.vue?vue&type=template&id=5b4b6e83&"
import script from "./PackageListDropdown.vue?vue&type=script&lang=js&"
export * from "./PackageListDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports